import {SortDirection} from '@angular/material/sort';
import {FabFilterDescriptor} from '@fabric/components/table-filter/data-query';

export class PagedRequest {
  page: number;
  pageSize: number;
  sortFields: string[];
  sortDirection: SortDirection;
  filters: FabFilterDescriptor[];
}
